import styled from "@emotion/styled";
import { Plus } from "react-feather";
import { StyledPropsWithTheme } from "../../utils/globalTypes";

const AddLogo = styled(Plus)<StyledPropsWithTheme>`
  color: ${({ theme }) => theme.palette.text.secondary};
`;

export const Styled = { AddLogo };
